import { Component} from "@angular/core";


@Component({
    templateUrl: './cert-overview.component.html'
})
export class CertOverviewComponent {
}